import { Box, Grid, Typography } from '@mui/material';
import moment from 'moment-timezone';
import React from 'react';

export const formatDate = (
  dateStr?: string | null,
  formatStr: string = 'DD-MMM-YYYY',
  fallback: string = 'N/A'
) => {
  if (!dateStr || !moment(dateStr).isValid()) {
    return fallback;
  }
  return moment.tz(dateStr, 'Asia/Dhaka').format(formatStr);
};

export const formatValue = (
  val?: string | number | null,
  fallback: string = 'N/A'
) => {
  if (val === undefined || val === null || val === '' || val === 'null') {
    return fallback;
  }
  return val;
};

interface DetailItemProps {
  label: string;
  value: React.ReactNode;
  labelWidth?: object | string | number;
  fallback?: string;
  xs?: number;
  sm?: number;
  md?: number;
  lg?: number;
}

export const CommonDetailItem = ({
  label,
  value,
  labelWidth = { xs: '120px', sm: '140px', md: '150px' },
  fallback = 'N/A',
  xs = 12,
  sm = 6,
  md = 4,
  lg,
}: DetailItemProps) => {
  let displayValue: React.ReactNode = value;

  if (
    value === undefined ||
    value === null ||
    value === '' ||
    value === 'null'
  ) {
    displayValue = fallback;
  }

  return (
    <Grid item xs={xs} sm={sm} md={md} lg={lg}>
      <Box sx={{ display: 'flex', alignItems: 'baseline' }}>
        <Typography
          variant='body1'
          fontWeight='bold'
          color='text.primary'
          sx={{
            minWidth: labelWidth,
            flexShrink: 0,
          }}
        >
          {label}
        </Typography>
        <Typography
          variant='body1'
          fontWeight='bold'
          color='text.primary'
          sx={{ mr: 1, flexShrink: 0 }}
        >
          :
        </Typography>
        <Box sx={{ flexGrow: 1, minWidth: 0, wordBreak: 'break-word' }}>
          {typeof displayValue === 'string' || typeof displayValue === 'number' ? (
            <Typography variant='body1' color='text.primary'>
              {displayValue}
            </Typography>
          ) : (
            displayValue
          )}
        </Box>
      </Box>
    </Grid>
  );
};

export default CommonDetailItem;
